import { Dimensions, StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    isTablet,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const RIBBON_CONTAINER_PADDING = widthPercentageToDP(16, 44, 72);
export const CAST_STRIPE_MARGIN_TOP = heightPercentageToDP(20, 16, 20);
const windowWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
    container: {
        marginTop: isWeb ? 0 : heightPercentageToDP(20, 16),
        paddingTop: isWeb ? heightPercentageToDP(20) : 0,
    },
    ribbonItem: {
        marginRight: isTablet ? 16 : 8,
    },
    movieContainer: {
        width: widthPercentageToDP(136),
        marginRight: widthPercentageToDP(8),
    },
    seriesContainer: {
        width: widthPercentageToDP(216, 206),
        marginRight: widthPercentageToDP(8),
    },
    personContainer: {
        width: widthPercentageToDP(136),
        marginRight: widthPercentageToDP(8),
    },
    programContainer: {
        width: widthPercentageToDP(288),
        marginRight: widthPercentageToDP(8),
    },
    episodeContainer: {
        width: widthPercentageToDP(216, 206),
        marginRight: widthPercentageToDP(8),
    },
    defaultContainer: {
        width: widthPercentageToDP(288),
        marginRight: widthPercentageToDP(8),
    },
    contentContainer: {
        paddingHorizontal: RIBBON_CONTAINER_PADDING,
    },
    chLogo: {
        position: 'absolute',
        top: 8,
        right: 8,
        height: 16,
    },
    catchupIcon: {
        position: 'absolute',
        right: 8,
        bottom: 8,
    },
    catchupIconOnLiveProgram: {
        bottom: 20,
    },
    bwdButton: {
        left: 80,
    },
    fwdButton: {
        right: 80,
    },
    channelStripeMarginTop: {
        marginTop: 20,
    },
    webSkeletonContainer: {
        width: windowWidth,
        height: heightPercentageToDP(260),
    },
    lastContainerMargin: {
        marginBottom: heightPercentageToDP(20, 16, 40),
    },
});

export default styles;
